export default {
    token: localStorage.getItem("token") || '',
    userName: localStorage.getItem('userName') || '',
    themeColor: localStorage.getItem('color') || '#eb5635',
    breadcrumbList: [],
    defaultActive: '',
    timeOptions:[{
        label: '今天',
        value: 1
    },{
        label: '昨天',
        value: 2
    },{
        label: '过去7天',
        value: 3
    },{
        label: '过去30天',
        value: 4
    }],
    isShowPackage:false,//显示套餐推荐
    isHome:true,//标记是否为首页的推荐套餐
    isShowPrice: false //显示充值弹框
  }



// WEBPACK FOOTER //
// ./src/store/state/state.js